/**
 * Estilos para o componente LanguageSelector.
 *
 * Este módulo contém o componente estilizado utilizado para renderizar
 * o seletor de idiomas na aplicação.
 *
 * @module LanguageSelector.Styles
 */

import styled from '@emotion/styled';

/**
 * Componente estilizado para o contêiner do seletor de idiomas.
 *
 * Define o estilo para o elemento select dentro do contêiner com:
 * - Altura fixa de 2.2rem
 * - Largura de 50% do contêiner pai
 * - Borda sutil em cinza claro
 * - Cantos levemente arredondados (2px)
 * - Tamanho de fonte pequeno (0.8rem)
 * - Texto em preto
 * - Sem contorno ao focar (outline: none)
 * - Alinhamento vertical centralizado
 * - Sombra sutil para efeito de elevação
 *
 * Este componente é projetado para estilizar o elemento select de forma
 * consistente com o design da aplicação.
 *
 * @type {import('@emotion/styled').StyledComponent}
 */
export const Selector = styled.div`
  select {
    height: 2.2rem;
    width: 50%;
    border: 0.5px solid rgba(207, 207, 207, 0.69);
    border-radius: 2px;
    font-size: 0.8rem;
    color: rgb(0, 0, 0);
    outline: none;
    align-items: center;
    box-shadow: 1px 1px 2px -1px rgba(207, 207, 207, 0.64);
  }
`;
